<script setup>
import CalculationDetails from './CalculationDetails.vue';
import CalculationTitle from './CalculationTitle.vue';
import CalculationTotal from './CalculationTotal.vue';
</script>

<template>
  <hr>
  <CalculationTitle/>
  <CalculationDetails/>
  <hr>
  <CalculationTotal/>
</template>
